/**
 * @file.
 * Contains PWA installation styles.
 */

import styled, { css } from 'styled-components';
import arrowRightSVG from 'common/assets/icons/common/arrows/pointers/white-right-arrow-pointer.svg';
import gameIconSVG from 'common/assets/icons/common/rock-west/rw-logo-white.svg';
import closeSVG from 'common/assets/icons/common/signs/white-close-sign.svg';

import { ifProp } from 'styled-tools';

export const PwaPopUpContainer = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 888888;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: ${ifProp('isStepTwo', '100vh', '170px')};
  padding: 25px 28px;
  background: rgba(17, 17, 17, 0.71);
  backdrop-filter: blur(20px);

  ${ifProp(
    'isChromeAndroid',
    css`
      justify-content: center;
      height: 250px;
      background-color: #fff;
    `
  )}

  ${ifProp(
    'isStepTwo',
    css`
      justify-content: center;
    `
  )}
`;

export const IOSPopUpInner = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 250px;
  max-height: 568px;
  height: 93vh;
  padding-bottom: 40px;
  padding-top: 40px;
`;

export const IOSTitle = styled.h3`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 264px;
  font-weight: normal;
  font-size: 14px;
  line-height: 150.5%;
  color: #ffffff;
`;

export const IOSInstallBtn = styled.button`
  position: relative;
  width: 264px;
  height: 50px;
  border: 0;
  background: linear-gradient(112.77deg, #2f4286 -2.16%, #0384e0 105.25%);
  text-align: center;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: -0.408px;
  color: #ffffff;
  cursor: pointer;

  &::after,
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-size: cover;
  }

  &::after {
    left: 20px;
    width: 33px;
    height: 17px;
    background: url(${gameIconSVG}) no-repeat;
  }

  &::before {
    right: 20px;
    width: 11px;
    height: 19px;
    background: url(${arrowRightSVG}) no-repeat;
  }
`;

export const PWACloseBtn = styled.button`
  width: 28px;
  height: 20px;
  border: 0;
  mask: url(${closeSVG}) no-repeat;
  mask-size: contain;
  background: ${ifProp('dark', 'rgba(48, 55, 66, 1)', '#fff')};
  cursor: pointer;

  ${ifProp(
    'dark',
    css`
      position: absolute;
      top: 20px;
      right: 20px;
    `
  )}
`;

export const IOSStepOneImg = styled.img`
  width: 250px;
  height: 32px;
`;

export const IOSStepBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 250px;
  height: 32px;
  padding: 15px;
  border-radius: 4px;
  background-color: #fff;
  font-weight: normal;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: -0.408px;
  color: #000000;
`;

export const BlueText = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: -0.408px;
  color: #0384e0;
`;

export const IOSStepTitle = styled.h5`
  margin-bottom: 10px;
  font-weight: normal;
  font-size: 14px;
  line-height: 150.5%;
  color: #ffffff;
`;

export const PlusImg = styled.img`
  width: 15px;
  height: 15px;
`;

export const StepThreeBlock = styled.div`
  display: flex;
  align-items: center;
  width: 250px;
  height: 75px;
  padding: 12px 10px;
  font-weight: normal;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: -0.408px;
  color: rgba(48, 55, 66, 0.46);
`;

export const ChromeBlock = styled.div`
  display: flex;
  align-items: center;
  width: 300px;
`;

export const RwLogo = styled.img`
  width: ${ifProp('big', '70px', '50px')};
  height: ${ifProp('big', '70px', '50px')};
  margin-right: 10px;
`;

export const IOSStepBoldText = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: -0.408px;
  color: #303742;

  ${ifProp(
    'border',
    css`
      border-bottom: 1px solid rgba(48, 55, 66, 0.46);
    `
  )}
`;

export const StepThreeVerticalFlexBlock = styled.div`
  background-color: #fff;
`;

export const WhiteBlock = styled.div`
  background-color: #fff;
`;

export const InstallBtn = styled.button`
  width: 284px;
  height: 40px;
  border: 0;
  margin-top: 50px;
  background: linear-gradient(112.77deg, #2f4286 -2.16%, #0384e0 105.25%);
  text-align: center;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
  cursor: pointer;
`;

export const ChromeText = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 150.5%;
  color: #303742;
`;

export const LightBlueText = styled.p`
  font-weight: normal;
  font-size: 16px;
  line-height: 150.5%;
  display: flex;
  align-items: center;
  color: #0384e0;
`;
